import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { HeaderControls, IHeaderControls } from '../HeaderControls';
import { Headline2 } from '../UI';

import styles from './page-header.module.scss';

import { useWidth } from 'hooks';

type IPageHeaderControls = IHeaderControls;

interface IPageHeaderProps {
  titleId: string;
  actions?: ReactNode;
  controls?: IPageHeaderControls;
  secondary?: ReactNode;
  className?: string;
  titleClassName?: string;
}

const PageHeader: FC<IPageHeaderProps> = props => {
  const { titleId, actions, controls, secondary, className, titleClassName } = props;
  const { isShow: isSearchOpen, setIsShow: setIsSearchOpen } = useWidth(true);
  const shouldHideTitleForSearch =
    !controls?.filters &&
    Boolean(controls?.search) &&
    controls?.search?.collapsible !== false &&
    isSearchOpen;

  return (
    <div
      className={classNames(styles['page-header'], className, {
        [styles.filterLayout]: Boolean(controls?.filters),
      })}
    >
      <div className={styles['page-header__row']}>
        <Headline2
          className={classNames(styles['page-header__title'], titleClassName, {
            [styles['page-header__title--search-open']]: shouldHideTitleForSearch,
          })}
        >
          <FormattedMessage id={titleId} />
        </Headline2>
        {(actions || controls) && (
          <div className={styles['page-header__actions']}>
            {actions ??
              (controls && (
                <HeaderControls
                  controls={controls}
                  isSearchOpen={isSearchOpen}
                  setIsSearchOpen={setIsSearchOpen}
                />
              ))}
          </div>
        )}
      </div>
      {secondary && <div className={styles['page-header__secondary']}>{secondary}</div>}
    </div>
  );
};

export { PageHeader };
